import React from "react";
import Avatar from "@mui/material/Avatar";

const Avtar = ({ user_name, size }) => {
  function getInitials(name) {
    // Check if the name is provided
    if (!name || typeof name !== "string") {
      return ""; // Return empty string if name is not provided or not a string
    }

    // Split the name into an array of words
    const words = name.trim().split(/\s+/);

    // Initialize a variable to store the initials
    let initials = "";

    // Iterate through each word to extract the first character
    for (const word of words) {
      // Append the first character of each word to the initials string
      initials += word.charAt(0);
    }

    // Return the initials in uppercase
    return initials.toUpperCase();
  }
  function stringAvatar(name) {
    return {
      children: getInitials(name),
    };
  }
  return (
    <Avatar
      {...stringAvatar(user_name)}
      title={user_name}
      sx={{ width: size, height: size, backgroundColor: "#E95757" }}
    />
  );
};

export default Avtar;
